// What an image is doing, in the caption of its card and in the detail panel's heading.
export function usageLabel(count) {
  if (!count) return 'Unused';
  return `${count} workflow step${count === 1 ? '' : 's'}`;
}
